(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-promes"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-promes-product]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    const variants = JSON.parse(section.querySelector('[data-variants-json]').textContent);
    const form = section.querySelector('.promes-product__form');
    const stage = section.querySelector('.promes-product__stage');
    const moneyFormat = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    const showMedia = (mediaId) => {
      const template = section.querySelector(`[data-media-template="${mediaId}"]`);
      if (!template || !stage) return;
      if (document.startViewTransition) document.startViewTransition(() => stage.replaceChildren(template.content.cloneNode(true)));
      else stage.replaceChildren(template.content.cloneNode(true));
      section.querySelectorAll('[data-media-trigger]').forEach((button) => {
        const active = button.dataset.mediaTrigger === String(mediaId);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    section.querySelectorAll('[data-media-trigger]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTrigger)));
    const updateVariant = () => {
      const selected = [...section.querySelectorAll('.promes-product__option input:checked')].map((input) => input.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      const addButton = section.querySelector('[data-add-to-cart]');
      const stickyButton = section.querySelector('[data-sticky-add]');
      const addLabel = section.querySelector('[data-add-label]');
      const availability = section.querySelector('[data-availability]');
      if (!variant) {
        addButton.disabled = true;
        if (stickyButton) stickyButton.disabled = true;
        return;
      }
      section.querySelector('[data-variant-id]').value = variant.id;
      section.querySelector('[data-current-price]').textContent = moneyFormat(variant.price);
      const compare = section.querySelector('[data-compare-price]');
      compare.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = variant.compare_at_price ? moneyFormat(variant.compare_at_price) : '';
      const availableText = variant.available ? section.dataset.addText : section.dataset.soldText;
      addButton.disabled = !variant.available;
      addLabel.textContent = availableText;
      availability.textContent = variant.available ? section.dataset.readyText : section.dataset.unavailableText;
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = availableText;
      }
      const stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = moneyFormat(variant.price);
      section.querySelectorAll('.promes-product__option').forEach((option) => {
        option.querySelector('[data-selected-option]').textContent = option.querySelector('input:checked')?.value || '';
      });
      if (variant.featured_media) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    section.querySelectorAll('.promes-product__option input').forEach((input) => input.addEventListener('change', updateVariant));
    section.querySelector('[data-sticky-add]')?.addEventListener('click', () => form.requestSubmit());
  });

  } catch(e) { console.error(e); }
})();
})();
